import * as Yup from 'yup';
import dayjs from 'dayjs';
export const applicationValidationSchema = Yup.object({
    state: Yup.string().required("State is required"),
    dpNumber: Yup.string()
        .required("DP/SP/CTS/OC number is required")
        .matches(/^\d{2,}([a-zA-Z]\d*)?$/, "Must be numbers only, optionally followed by a letter and numbers. Do not include prefixes or building names. Valid examples: '12345', '12345M', '12345M1'"),
    lotNumber: Yup.string().required("Lot number is required"),
    // qldBrand: Yup.string().required("QLD brand is required"),
    // nswBrand: Yup.string().required("NSW brand is required"),
    brand: Yup.string().required("Brand is required"),
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    contactNumber: Yup.string().required("Contact number is required"),
    address: Yup.string().required("Address is required"),
    suburb: Yup.string().required("Suburb is required"),
    postcode: Yup.string().required("Postcode is required"),
    country: Yup.string().required("Country is required"),
    statusToRecords: Yup.string().required("Applicant's status to scheme records is required"),
    // layeredSchemeStatus: Yup.string().required("Layered scheme status is required"),
    //formik.values.statusToRecords === "agent_appointed_by_the_requestor" || formik.values.statusToRecords === "another_person_with_a_proper_interest_in_the_information_sought"
    files: Yup.array().when(['statusToRecords', 'state'], { 
        is: (statusToRecords, state) => 
            (statusToRecords === 'agent_appointed_by_the_requestor' || 
             statusToRecords === 'another_person_with_a_proper_interest_in_the_information_sought') ||
            (statusToRecords === 'prospective_lot_buyer' && state === 'NSW'),
        then: () => Yup.array()
            .min(1, "File is required")
            .test("fileType", "Only PDF files are allowed", (value) => {
                if (!value) return true;
                return value.every(file => file.type === "application/pdf");
            })
            .test("fileSize", "Files must be less than 10MB", (value) => {
                if (!value) return true;
                return value.every(file => file.size <= 10 * 1024 * 1024); // 10MB in bytes
            })
    }),
    agencyName: Yup.string().when('statusToRecords', { is: 'agent_appointed_by_the_requestor', then: () => Yup.string().required("Agency name is required") }),
    // agentFirstName: Yup.string().when('statusToRecords', { is: 'agent_appointed_by_the_requestor', then: () => Yup.string().required("Agent first name is required") }),
    // agentLastName: Yup.string().when('statusToRecords', { is: 'agent_appointed_by_the_requestor', then: () => Yup.string().required("Agent last name is required") }),
    // agentEmail: Yup.string().when('statusToRecords', { is: 'agent_appointed_by_the_requestor', then: () => Yup.string().email("Invalid email format").required("Agent email is required") }),
    // agentContactNumber: Yup.string().when('statusToRecords', { is: 'agent_appointed_by_the_requestor', then: () => Yup.string().required("Agent contact number is required") }),
    readAndAccepted: Yup.boolean().required("You must agree to the terms and conditions").oneOf([true], "You must agree to the terms and conditions"),
    hours: Yup.number().required("Hours are required").min(1, "Hours must be greater than 0").max(4, "Hours must be less than 24"),
    date: Yup.date().required("Date is required").min(dayjs(new Date()), "Date must be in the future")
});

export const paymentValidationSchema = Yup.object({
    cardNumber: Yup.string()
        .required("Card number is required")
        .transform((value) => value.replace(/[\s-]/g, '')) // Remove spaces and hyphens
        .matches(
            /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11})$/,
            "Invalid card number"
        ),
    cardName: Yup.string().required("Card name is required"),
    expiryMonth: Yup.string().required("Expiry month is required").matches(/^(0[1-9]|1[0-2])$/, "Invalid expiry month"),
    expiryYear: Yup.string()
        .required("Expiry year is required")
        .matches(/^20[2-9][0-9]$/, "Expected YYYY format")
        .test("expiry", "Year must not be in the past", (value) => {
            if (!value) return false;
            const currentYear = new Date().getFullYear();
            return parseInt(value) >= currentYear;
        }),
    cvn: Yup.string()
        .required("CVN is required")
        .matches(/^[0-9]{3,4}$/, "Invalid CVN"),
    billingAddress: Yup.string().required("Billing address is required"),
    billingSuburb: Yup.string().required("Billing suburb is required"),
    billingPostcode: Yup.string().required("Billing postcode is required"),
    billingState: Yup.string().required("Billing state is required"),
    billingCountry: Yup.string().required("Billing country is required")
});